<aside class="sidebar shadow-sm">

    <div class="sidebar-profile d-flex flex-column justify-content-center pt-5 pb-3">
      <div class="picture-wrapper mb-4">
        <div class="user-picture m-auto">
          <img src={{avatar}} class="img-fluid" alt="">
        </div>
      </div>
      <div class="profile-details text-center pb-4">
        <p class="mb-0 text-uppercase name">{{name}}</p>
      </div>
    </div>
    <div class="sidebar-search pt-1 pb-1 ps-3 pe-3">
      <input type="search" class="form-control rounded-pill" name="search" placeholder="Search ...">
    </div>
    <nav class="sidebar-menu pt-3 pb-3">
      <div class="menu-header mt-3 mb-2">
        Menu
      </div>
      <ul class="menu-items">
        <li >
          <a routerLink="/pdg/home" >
            <i class="fa-solid fa-gauge-high"></i>
            <span>Dashboard</span>
          </a>
        </li>
        <li>
          <a *ngIf="proj == true" (click)="collapse.toggle()" [attr.aria-expanded]="!isCollapsed">
            <i class="fa-solid fa-folder-open"></i>
            <span>Proyectos</span>
          </a>
          <div #collapse="ngbCollapse" class="bg-red" [(ngbCollapse)]="proyectos">
            <div class="">
              <div class="ms-3">
                <a *ngIf="proj_list == true" routerLink="/pdg/project/list" routerLinkActive="active" (click)="onclickSelect('proyectos')" >
                  <i class="fa-solid fa-file-lines"></i>
                  <span>Listado</span>
                </a>
                <a *ngIf="proj_create == true" routerLink="/pdg/project/creating" routerLinkActive="active" (click)="onclickSelect('proyectos')" >
                  <i class="fa-solid fa-file-circle-plus"></i>
                  <span>Crear</span>
                </a>
              </div>
            </div>
          </div>
        </li>

        <!-- <li>
          <a (click)="collapse.toggle()" [attr.aria-expanded]="!isCollapsed">
            <i class="fa-solid fa-folder-open"></i>
            <span>Proyectos</span>
          </a>
          <div #collapse="ngbCollapse" class="bg-red" [(ngbCollapse)]="proyectos">
            <div class="">
              <div class="ms-3">
                <a routerLink="/pdg/project/list" routerLinkActive="active" (click)="onclickSelect('proyectos')" >
                  <i class="fa-solid fa-file-lines"></i>
                  <span>Listado</span>
                </a>
                <a routerLink="/pdg/project/creating" routerLinkActive="active"  (click)="onclickSelect('proyectos')">
                  <i class="fa-solid fa-file-circle-plus"></i>
                  <span>Crear</span>
                </a>
              </div>
            </div>
          </div>
        </li> -->
         <!-- <li>
          <a *ngIf="taa == true" (click)="collapse.toggle()" [attr.aria-expanded]="!isCollapsed">
            <i class="fa-solid fa-user-astronaut"></i>
            <span class="cursor">Tass</span>
          </a>
          <div  #taass="ngbCollapse" class="bg-red" [(ngbCollapse)]="taas">
            <div class="">
              <div class="ms-3">
                <div *ngFor="let item of permisos_menu">
                <a *ngIf="item == 5" routerLink="/pdg/taas/list" routerLinkActive="active" (click)="onclickSelect('taas')" >
                  <i class="fa-solid fa-users"></i>
                  <span>Listado</span>
                </a>
                <a *ngIf="item == 6" routerLink="/pdg/taas/creating" routerLinkActive="active" (click)="onclickSelect('proyectos')" >
                  <i class="fa-solid fa-file-lines"></i>
                  <span>Crear</span>
                </a>
              </div>
              </div>
            </div>
          </div>
        </li> -->

        <li>
          <a *ngIf="taa == true"  (click)="taass.toggle()" [attr.aria-expanded]="!isCollapsed">
            <i class="fa-solid fa-user-astronaut"></i>
            <span class="cursor">Tass</span>
          </a>
          <div  #taass="ngbCollapse" class="bg-red" [(ngbCollapse)]="taas">
            <div class="">
              <div class="ms-3">
                <a *ngIf="taas_list == true" routerLink="/pdg/taas/list" routerLinkActive="active" (click)="onclickSelect('taas')" >
                  <i class="fa-solid fa-users"></i>
                  <span>Listado</span>
                </a>
                <a *ngIf="taas_create == true" routerLink="/pdg/taas/creating" routerLinkActive="active"  (click)="onclickSelect('taas')" >
                  <i class="fa-solid fa-user-plus"></i>
                  <span>Crear</span>
                </a>
            </div>
          </div>
          </div>
        </li>

        <li>
          <a *ngIf="serv == true" (click)="servicioss.toggle()" [attr.aria-expanded]="!isCollapsed">
            <i class="fa-solid fa-truck-fast"></i>
            <span>Servicios</span>
          </a>
          <div #servicioss="ngbCollapse" class="bg-red" [(ngbCollapse)]="servicios">
            <div class="">
              <div class="ms-3">
                <a  *ngIf="serv_list == true" routerLink="/pdg/service/list" routerLinkActive="active" (click)="onclickSelect('servicios')">
                  <i class="fa-solid fa-clipboard-list"></i>
                  <span>Listado</span>
                </a>
                <a  *ngIf="serv_create == true" routerLink="/pdg/service/creating" routerLinkActive="active" (click)="onclickSelect('servicios')">
                  <i class="fa-solid fa-cart-plus"></i>
                  <span>Crear</span>
                </a>
            </div>
          </div>
          </div>
        </li>


        <li>
          <a *ngIf="ejec == true" (click)="ejecute.toggle()" [attr.aria-expanded]="!isCollapsed">
            <i class="fa-solid fa-address-book"></i>
            <span>Ejecutivo</span>
          </a>

          <div #ejecute="ngbCollapse" class="bg-red" [(ngbCollapse)]="ejecu">
            <div class="">
              <div class="ms-3">
                <a  *ngIf="ejec_ubication == true" routerLink="/pdg/ejecutive/location" routerLinkActive="active" (click)="onclickSelect('ejecu')">
                  <i class="fa-solid fa-map-location-dot"></i>
                  <span>Ubicación</span>
                </a>
                <a  *ngIf="osm == true" routerLink="/pdg/ejecutive/osm-panel" routerLinkActive="active" (click)="onclickSelect('ejecu')">
                  <i class="fa-solid fa-clipboard-list"></i>
                  <span>Panel OSM</span>
                </a>
            </div>
          </div>
          </div>
        </li>


        <li>
          <a *ngIf="finance == true" routerLinkActive="active" (click)="finann.toggle()" [attr.aria-expanded]="!isCollapsed">
           <i class="fa-solid fa-scale-balanced"></i>
            <span>Finanza</span>
          </a>
          <div #finann="ngbCollapse" class="bg-red" [(ngbCollapse)]="finan">
            <div class="">
              <div class="ms-3"> 
                <a  *ngIf="finance_hes == true" routerLink="/pdg/finance/hes/1" routerLinkActive="active" (click)="onclickSelect('finan')">
                  <i class="fa-solid fa-file-invoice-dollar"></i>
                  <span>Listado HES</span>
                </a>
                <a  *ngIf="paymentTrainPending == true" routerLink="/pdg/finance/pending-payment-train" routerLinkActive="active" (click)="onclickSelect('finan')">
                  <i class="fa-solid fa-chart-line"></i>
                  <span>Tren de Pagos Resumen</span>
                </a>
                <a  *ngIf="paymentTrainPendingDetail == true" routerLink="/pdg/finance/pending-payment-train-detail" routerLinkActive="active" (click)="onclickSelect('finan')">
                  <i class="fa-solid fa-chart-line"></i>
                  <span>Tren de Pagos Detalle</span>
                </a>
            </div>
          </div>
          </div>
        </li>


        <li>
          <a  *ngIf="leadership == true" routerLinkActive="active" (click)="jefae.toggle()" [attr.aria-expanded]="!isCollapsed">
            <i class="fa-solid fa-user-gear"></i>
            <span>Jefatura</span>
          </a>
          <div #jefae="ngbCollapse" class="bg-red" [(ngbCollapse)]="jefa">
            <div class="">
              <div class="ms-3">
                <a  *ngIf="leadership_payment == true" routerLink="/pdg/headship/payments" routerLinkActive="active" (click)="onclickSelect('jefa')">
                  <i class="fa-solid fa-hand-holding-dollar"></i>
                  <span>Pagos</span>
                </a>
                <a  *ngIf="forecast == true" routerLink="/pdg/headship/forecast" routerLinkActive="active" (click)="onclickSelect('jefa')">
                  <i class="fa-solid fa-chart-line"></i>
                  <span>Forecast</span>
                </a>
                <a  *ngIf="forecastDetail == true" routerLink="/pdg/headship/forecast-detail" routerLinkActive="active" (click)="onclickSelect('jefa')">
                  <i class="fa-solid fa-chart-line"></i>
                  <span>Forecast detalle</span>
                </a>
                <a  *ngIf="forecastTrain == true" routerLink="/pdg/headship/forecast-payment-train" routerLinkActive="active" (click)="onclickSelect('jefa')">
                  <i class="fa-solid fa-chart-line"></i>
                  <span>For. Cliente anual</span>
                </a>
                <a  *ngIf="forecastTrainDetail == true" routerLink="/pdg/headship/forecast-payment-train-detail" routerLinkActive="active" (click)="onclickSelect('jefa')">
                  <i class="fa-solid fa-chart-line"></i>
                  <span>For. cliente detalle anual</span>
                </a>
              </div>
            </div>
          </div>
        </li>

        <li>
          <a *ngIf="customer == true" routerLinkActive="active" (click)="clientess.toggle()" [attr.aria-expanded]="!isCollapsed">
            <i class="fa-solid fa-user-tie"></i>
            <span>Clientes</span>
          </a>
          <div #clientess="ngbCollapse" class="bg-red" [(ngbCollapse)]="clientes">
            <div class="">
              <div class="ms-3">
                <a *ngIf="customer_list == true" routerLink="/pdg/client/list" routerLinkActive="active" (click)="onclickSelect('clientes')">
                  <i class="fa-solid fa-user-group"></i>
                  <span>Listado</span>
                </a>
                <a  *ngIf="customer_create == true" routerLink="/pdg/client/create" routerLinkActive="active" (click)="onclickSelect('clientes')">
                  <i class="fa-solid fa-user-plus"></i>
                  <span>Crear</span>
                </a>
              </div>
            </div>
          </div>
        </li>


        <li>
          <a  *ngIf="administration == true" routerLinkActive="active" (click)="admins.toggle()" [attr.aria-expanded]="!isCollapsed">
            <i class="fa-solid fa-screwdriver-wrench"></i>
            <span>Administracion</span>
          </a>
          <div #admins="ngbCollapse" class="bg-red" [(ngbCollapse)]="admin">
            <div class="">
              <div class="ms-3">
                <!-- <a *ngIf="item == 21" routerLink="/pdg/admin/role/list" routerLinkActive="active" (click)="onclickSelect('admin')">
                  <i class="fa-solid fa-users"></i>
                  <span>Roles</span>
                </a> -->
                <a *ngIf="administration_list_user == true" routerLink="/pdg/admin/user/list"routerLinkActive="active" (click)="onclickSelect('admin')">
                  <i class="fa-solid fa-users"></i>
                  <span>Listado de Usuarios</span>
                </a>
                <a  *ngIf="administration_project_etap == true" routerLink="/pdg/admin/stages/list" routerLinkActive="active" (click)="onclickSelect('admin')">
                <i class="fa-solid fa-person-circle-plus"></i>
                  <span>Etapas de Proyecto</span>
                </a>
                <a  *ngIf="administration_cost == true" routerLink="/pdg/admin/cost/list" routerLinkActive="active" (click)="onclickSelect('admin')">
                <i class="fa-solid fa-dollar-sign"></i>
                  <span>Costos</span>
                </a>
                <a  *ngIf="administration_asig == true"  routerLink="/pdg/admin/assign/list" routerLinkActive="active" (click)="onclickSelect('admin')">
                <i class="fa-solid fa-briefcase"></i>
                  <span>Regularizar Asignaciones</span>
                </a>
                <a  *ngIf="administration_leader == true"  routerLink="/pdg/admin/leader/list" routerLinkActive="active" (click)="onclickSelect('admin')">
                <i class="fa-solid fa-user-plus"></i>
                  <span>Lista de lider</span>
                </a>
              </div>
            </div>
            </div>
        </li>


        <li>
          <a  *ngIf="generate_payroll_excel == true" routerLink="/pdg/payroll/generate-payroll-excel" routerLinkActive="active" (click)="onclickSelect('excel')">
            
            <i class="fa-solid fa-users-gear"></i>
            <span>Generar nomina</span>
          </a>
        </li>
        
        <li>
          <a  *ngIf="permissions_and_roles == true" routerLinkActive="active" (click)="roless.toggle()" [attr.aria-expanded]="!isCollapsed">
           
            <i class="fa-solid fa-users-gear"></i>
            <span>Permisos y Roles</span>
          </a>
          <div #roless="ngbCollapse" class="bg-red" [(ngbCollapse)]="roles">
            <div class="">
              <div class="ms-3">
              
                <a  *ngIf="permissions_and_roles_permissions == true" routerLink="/pdg/roles/user/list"routerLinkActive="active" (click)="onclickSelect('roles')">
                  <i class="fa-solid fa-users"></i>
                  <span>Listado de Usuarios</span>
                </a>
                <a  *ngIf="permissions_and_roles_rol == true" routerLink="/pdg/roles/list" routerLinkActive="active" (click)="onclickSelect('roles')">
                  <i class="fa-solid fa-user-check"></i>
                  <span>Roles</span>
                </a>
              </div>
            </div>
            </div>
        </li>
      </ul>
      <div class="menu-header mt-4 mb-4">
        Zentown
      </div>
      <div class="view-source mb-3">
        <a href="https://zentown.cl/" target="_blank" class="btn d-md-block btn-outline-success rounded-2">Ir a Zentown</a>
      </div>   
    </nav>
  </aside>